import { default as en } from "./en.js";

const languages: any = {
  en,
};

export default languages;
